"use client"
import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('df-theme');
      if (saved) return saved;
      
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
  });

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
  };

  const setSpecificTheme = (newTheme) => {
    setTheme(newTheme);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('df-theme', theme);

      const applyToDialogflow = () => {
        const dfMessenger = document.querySelector('df-messenger');
        if (dfMessenger) {
          if (theme === 'dark') {
            dfMessenger.setAttribute('data-theme', 'dark');
          } else {
            dfMessenger.removeAttribute('data-theme');
          }
        } else {
          // Retry after a short delay if df-messenger isn't ready yet
          setTimeout(applyToDialogflow, 500);
        }
      };

      // Apply immediately and also after a delay
      applyToDialogflow();
      setTimeout(applyToDialogflow, 1000);
      setTimeout(applyToDialogflow, 2000);
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme: setSpecificTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};